import { EventEmitter, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { LocalStorageHelpers } from 'app/helpers';
import { AnalyticsService } from 'app/services';
import { Router } from '@angular/router';
import { ChartConfigModel } from 'app/interfaces';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';
var AppLinearGraphComponent = /** @class */ (function () {
    function AppLinearGraphComponent(localStorageHelpers, analyticsService, router) {
        this.localStorageHelpers = localStorageHelpers;
        this.analyticsService = analyticsService;
        this.router = router;
        this.year = null;
        this.published_at = null;
        this.ready = new EventEmitter(true);
        this.loading = true;
        this.noResults = true;
        this.daysBehind = this.forceAllOfAll ? 9999 : 30;
    }
    Object.defineProperty(AppLinearGraphComponent.prototype, "isCurrentYear", {
        get: function () {
            return this.year === new Date().getFullYear();
        },
        enumerable: true,
        configurable: true
    });
    AppLinearGraphComponent.prototype.ngOnInit = function () {
        if (this.localStorageHelpers.get('userData')) {
            var userData = JSON.parse(this.localStorageHelpers.get('userData'));
            this.threshold =
                userData['Profile'] && userData['Profile']['views_threshold']
                    ? userData['Profile']['views_threshold']
                    : 0;
        }
        if (this.router.url.indexOf('dashboard') > -1) {
            if (this.type === 'joboffers' && this.subset === 1) {
                this.chartConfig.navigate_label = 'Recruiting';
            }
            if (this.type === 'posts' && this.subset === 1) {
                this.chartConfig.navigate_label = 'Articles';
            }
            if (this.type === 'polls' && this.subset === 1) {
                this.chartConfig.navigate_label = 'Polls';
            }
        }
    };
    AppLinearGraphComponent.prototype.ngOnChanges = function (changes) {
        this.daysBehind = this.forceAllOfAll ? 9999 : 30;
        // if (changes.year && changes.year.currentValue !== null) {
        //   this.daysBehind = 9999;
        //   this.chartConfig.year = changes.year.currentValue;
        // }
        // console.log(new Date(), changes);
        this.setup();
    };
    // html select
    AppLinearGraphComponent.prototype.daysBehindChanged = function (event) {
        if (event !== this.chartConfig.daysBehind) {
            this.chartConfig.daysBehind = event === null ? null : parseInt(event, 10);
            this.daysBehind = this.chartConfig.daysBehind;
            this.setup();
        }
    };
    // calling api, set data, calculate and fill empty days
    AppLinearGraphComponent.prototype.setup = function () {
        var _this = this;
        this.loading = true;
        this.ready.emit(false);
        this.chartConfig = new ChartConfigModel(this.subset, this.daysBehind, this.year);
        this.chartConfig.for = this.type;
        this.chartConfig.id = this.id;
        this.daysBehind = this.chartConfig.daysBehind;
        // Call api based on type && id
        var apiCall;
        var subscription;
        switch (this.type) {
            case 'joboffers': {
                this.chartConfig.title = 'Job offer analytics';
                apiCall = this.analyticsService.getJobsGraph(null, this.id, this.chartConfig.daysBehind, this.year);
                subscription = apiCall.subscribe(function (results) {
                    _this.chartConfig.start = results.start;
                    _this.chartConfig.end = results.end;
                    _this.chartConfig.bucketSize = results.bucketSize;
                    if (_this.subset === 0) {
                        _this.chartConfig.prepareDataset(0, _this.external ? 'clicks' : 'applications', results['applications']);
                        _this.chartConfig.prepareDataset(1, 'views', results['views'], 'y-axis-2');
                        _this.chartConfig.ctrLabel = 'CTR';
                    }
                    else if (_this.subset === 1) {
                        _this.chartConfig.title = 'Applications analytics';
                        _this.chartConfig.prepareDataset(0, 'applications', results['applications']);
                    }
                    else if (_this.subset === 2) {
                        _this.chartConfig.title = 'Views analytics';
                        _this.chartConfig.prepareDataset(0, 'views', results['views']);
                    }
                    _this.finalize(subscription);
                });
                break;
            }
            case 'webinar': {
                this.chartConfig.title = 'Webinar analytics';
                apiCall = this.analyticsService.getWebinarGraph(null, this.id, this.chartConfig.daysBehind, this.year);
                subscription = apiCall.subscribe(function (results) {
                    _this.chartConfig.start = results.start;
                    _this.chartConfig.end = results.end;
                    _this.chartConfig.bucketSize = results.bucketSize;
                    if (_this.subset === 0) {
                        _this.chartConfig.prepareDataset(0, 'applications', results['applications']);
                        _this.chartConfig.prepareDataset(1, 'views', results['views'], 'y-axis-2');
                        _this.chartConfig.ctrLabel = 'CTR';
                    }
                    else if (_this.subset === 1) {
                        _this.chartConfig.title = 'Participations analytics';
                        _this.chartConfig.prepareDataset(0, 'participations', results['applications']);
                    }
                    else if (_this.subset === 2) {
                        _this.chartConfig.title = 'Views analytics';
                        _this.chartConfig.prepareDataset(0, 'views', results['views']);
                    }
                    _this.finalize(subscription);
                });
                break;
            }
            case 'events': {
                this.chartConfig.title = 'Event analytics';
                apiCall = this.analyticsService.getEventsGraph(this.id, null, this.year);
                subscription = apiCall.subscribe(function (results) {
                    console.log('getEventsGraph', results);
                    _this.chartConfig.start = results.start;
                    _this.chartConfig.end = results.end;
                    _this.chartConfig.bucketSize = results.bucketSize;
                    _this.chartConfig.prepareDataset(0, 'check-ins during event', results.checkins);
                    _this.finalize(subscription);
                });
                break;
            }
            case 'posts': {
                this.chartConfig.title = 'Article Analytics';
                apiCall = this.analyticsService.getPostsGraph(null, this.id, this.chartConfig.daysBehind, this.year);
                subscription = apiCall.subscribe(function (results) {
                    _this.chartConfig.start = results.start;
                    _this.chartConfig.end = results.end;
                    // if (this.published_at) {
                    //   this.chartConfig.published_at = this.chartConfig.getFormattedDate(this.published_at);
                    // }
                    _this.chartConfig.bucketSize = results.bucketSize;
                    if (_this.subset === 1) {
                        _this.chartConfig.title = 'Views analytics';
                        _this.chartConfig.prepareDataset(0, 'views', results['views']);
                    }
                    else if (_this.subset === 2) {
                        _this.chartConfig.title = 'Impressions analytics';
                        _this.chartConfig.prepareDataset(0, 'impressions', results['impressions']);
                    }
                    else if (_this.subset === 0) {
                        _this.chartConfig.prepareDataset(0, 'views', results['views']);
                    }
                    _this.finalize(subscription);
                });
                break;
            }
            case 'polls': {
                this.chartConfig.title = 'Polls Analytics';
                apiCall = this.analyticsService.getPollsGraph(null, this.id, this.chartConfig.daysBehind, this.year);
                subscription = apiCall.subscribe(function (results) {
                    _this.chartConfig.start = results.start;
                    _this.chartConfig.end = results.end;
                    _this.chartConfig.bucketSize = results.bucketSize;
                    if (_this.subset === 1) {
                        _this.chartConfig.title = 'Answers analytics';
                        _this.chartConfig.prepareDataset(0, 'answers', results['answers']);
                    }
                    else if (_this.subset === 2) {
                        _this.chartConfig.title = 'Views analytics';
                        _this.chartConfig.prepareDataset(0, 'views', results['views']);
                    }
                    else if (_this.subset === 0) {
                        _this.chartConfig.prepareDataset(0, 'answers', results['answers']);
                        _this.chartConfig.prepareDataset(1, 'views', results['views']);
                    }
                    _this.finalize(subscription);
                });
                break;
            }
            case 'total': {
                this.chartConfig.title = 'Total views analytics';
                this.chartConfig.cumulative = true;
                this.chartConfig.showThreshold = true;
                this.chartConfig.threshold = this.threshold;
                apiCall = this.analyticsService.getTotalViewsGraph(null, this.chartConfig.daysBehind, this.year);
                subscription = apiCall.subscribe(function (results) {
                    _this.chartConfig.start = results.start;
                    _this.chartConfig.end = results.end;
                    _this.chartConfig.bucketSize = results.bucketSize;
                    _this.chartConfig.prepareDataset(0, 'views', results['views']);
                    _this.finalize(subscription);
                });
                break;
            }
            default: {
                this.loading = false;
                this.ready.emit(true);
                this.noResults = this.chartConfig.datasetsAreEmpty;
            }
        }
    };
    AppLinearGraphComponent.prototype.finalize = function (subscription) {
        subscription.unsubscribe();
        this.loading = false;
        this.ready.emit(true);
        // setTimeout(() => {
        //   if (this.chart && this.chart.chart) {
        //     this.chart.chart.update();
        //   }
        // }, 250);
        this.noResults = this.chartConfig.datasetsAreEmpty;
    };
    AppLinearGraphComponent.prototype.navigate = function () {
        var section = 'recruiting';
        if (this.type === 'posts') {
            section = 'articles';
        }
        if (this.type === 'polls') {
            section = 'polls';
        }
        this.router.navigate(['/' + section]);
    };
    return AppLinearGraphComponent;
}());
export { AppLinearGraphComponent };
